import {SET_REPORT_PARAMS} from "../graduatesOrientationReducer";


const initialState = {}

export const reportParamsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REPORT_PARAMS:
            return action.payload;
        default:
            return state;
    }
};